import Service, { service } from '@ember/service';
import fetch from 'fetch';

import type StoreService from '@ember-data/store';

export default class DeepDiveService extends Service {
  @service declare store: StoreService;

  async query<Row>(
    slug: string,
    hotelUuid: string,
    params: Record<string, string> = {},
    { signal }: { signal?: AbortSignal } = {}
  ): Promise<Row[]> {
    const adapter = this.store.adapterFor('deep-dive');
    const response = await fetch(
      `${adapter.buildURL()}/${slug}/${hotelUuid}?${new URLSearchParams(
        params
      )}`,
      {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          ...adapter.headers,
        },
        signal,
      }
    );

    if (!response.ok) {
      adapter.ensureResponseAuthorized(response.status);

      const body = (await response.json().catch(() => undefined)) as
        | { error?: string }
        | undefined;

      throw new Error(
        body?.error || `Deep dive query failed with status ${response.status}.`
      );
    }

    return ((await response.json()) as { data: Row[] }).data;
  }
}

declare module '@ember/service' {
  interface Registry {
    'deep-dive': DeepDiveService;
  }
}
